import {
    getPendingEngineSessionRefresh,
    refreshEngineSession,
} from '@/services/engine/engine-client';
import { HttpClient } from '@/services/http-client';

export const viinexClient = new HttpClient({
    refreshSession: refreshEngineSession,
    pendingSessionRefresh: getPendingEngineSessionRefresh,
});
